import { Yup } from "components/DynamicForm/utils";

const form = {
    sections: [{
        fields: [
            [
                {
                    "type": "text",
                    "name": "tracking_num",
                    "label": "Tracking number",
                    "validation": Yup.string().required(),
                    "disabled": false,
                    "sizing": {
                        "sm": 6
                    }
                },
            ]
        ]
    }]
};


export default form;